import React from 'react';
import styles from './Bar.module.scss';
function Bar({ height, vp = 0, hp = 0, aside, children }) {
    return (React.createElement("div", { className: styles.wrap, style: { height: height ? `${height}px` : undefined, padding: `${vp}px ${hp}px` } },
        React.createElement("div", { className: styles.content }, children),
        aside && React.createElement("div", { className: styles.aside }, aside)));
}
export default Bar;
